import React, { memo, useEffect, useRef, useState } from "react";
import styles from "../ABheader.scss";
import NavRightComponent from "./NavRight/NavRight";
import MainNavigationComponent from "./MainNavigation/MainNavigation";
import TalkToAnExpert from "../../TalkToAnExpert";
import { isDesktop } from "utils/deviceType";
const {
  container,
  navbar_header,
  inside_header,
  hamburger,
  hamburger_img,
  line,
  top,
  middle,
  bottom,
  brand_column,
  logo_text,
  short_logo,
  overlay,
  bg_overlay,
} = styles;

export default function NavHeader({
  content,
  isNavbarExpanded,
  setIsNavbarExpanded,
  setShowOverlay,
  flowName,
  LeadProduct,
  LineOfBusiness,
  onTalkToExpertClickCallback,
  onTalkToExpertSubmitCallback,
}) {
  const { top_header, nav_header, nav_right } = content;
  const [activeHeadingIndex, setActiveHeadingIndex] = useState(null);
  const [isUserDrawerOpen, setIsUserDrawerOpen] = useState(false);
  const [showTalkToAnExpert, setShowTalkToAnExpert] = useState(false);

  useEffect(() => {
    if (showTalkToAnExpert) {
      setActiveHeadingIndex(null);
      setIsUserDrawerOpen(false);
      setIsNavbarExpanded(false);
    }
  }, [showTalkToAnExpert]);

  useEffect(() => {
    if (isUserDrawerOpen) {
      setActiveHeadingIndex(null);
      setIsNavbarExpanded(false);
    }
  }, [isUserDrawerOpen]);
  const handleHeadingClick = (index) => {
    activeHeadingIndex == index ? setActiveHeadingIndex(null) : setActiveHeadingIndex(index);
    setIsUserDrawerOpen(false);
  };

  const handleHamburgerClick = () => {
    if (activeHeadingIndex == null) setActiveHeadingIndex(0);
    else setActiveHeadingIndex(null);
    setIsNavbarExpanded(!isNavbarExpanded);
  };
  useEffect(() => {
    if (!isDesktop()) {
      if (isNavbarExpanded || isUserDrawerOpen) setShowOverlay(true);
      else setShowOverlay(false);
    } else {
      if (isNavbarExpanded || activeHeadingIndex != null || isUserDrawerOpen) {
        setShowOverlay(true);
      } else {
        setShowOverlay(false);
      }
    }
  }, [isNavbarExpanded, activeHeadingIndex, isUserDrawerOpen]);

  return (
    <nav className={navbar_header}>
      <div className={container}>
        <div className={inside_header}>
          <HamburgerComponent onClick={handleHamburgerClick} />
          <BrandColumnComponent /> {/* Airtel Business logo */}
          <MainNavigationComponent
            top_header={top_header}
            nav_header={nav_header}
            activeHeadingIndex={activeHeadingIndex}
            handleHeadingClick={handleHeadingClick}
            setActiveHeadingIndex={setActiveHeadingIndex}
            setShowTalkToAnExpert={setShowTalkToAnExpert}
            onTalkToExpertClickCallback={onTalkToExpertClickCallback}
            flowName={flowName}
          />
          <NavRightComponent
            nav_right={nav_right}
            isUserDrawerOpen={isUserDrawerOpen}
            setIsUserDrawerOpen={setIsUserDrawerOpen}
            setShowTalkToAnExpert={setShowTalkToAnExpert}
            onTalkToExpertClickCallback={onTalkToExpertClickCallback}
            flowName={flowName}
          />
          <TalkToAnExpert
            flowName={flowName}
            showTalkToAnExpert={showTalkToAnExpert}
            setShowTalkToAnExpert={setShowTalkToAnExpert}
            LeadProduct={LeadProduct}
            LineOfBusiness={LineOfBusiness}
            onSubmit={onTalkToExpertSubmitCallback}
          />
        </div>
      </div>
    </nav>
  );
}

const HamburgerComponent = memo(({ onClick }) => (
  <div className={hamburger} onClick={onClick}>
    <svg className={hamburger_img} viewBox="15 15 65 65">
      <path className={`${line} ${top}`} d="m 70,33 h -40 c 0,0 -8.5,-0.149796 -8.5,8.5 0,8.649796 8.5,8.5 8.5,8.5 h 20 v -20" />
      <path className={`${line} ${middle}`} d="m 70,50 h -40" />
      <path
        className={`${line} ${bottom}`}
        d="m 30,67 h 40 c 0,0 8.5,0.149796 8.5,-8.5 0,-8.649796 -8.5,-8.5 -8.5,-8.5 h -20 v 20"
      />
    </svg>
  </div>
));
const BrandColumnComponent = memo(() => (
  <div className={brand_column}>
    <a href="https://airtel.in/business/" aria-label="Airtel Business homepage">
      <svg width="108" viewBox="0 0 108 34" fill="none">
        <title id="logoTitle">Airtel Business logo</title>
        <path
          className={logo_text}
          d="M40 22.8315V11.3877H44.944C47.1123 11.3877 48.4369 12.8455 48.4369 14.5899C48.4369 15.5085 47.9645 16.4438 47.1798 16.8989C48.2513 17.354 48.8672 18.3989 48.8672 19.5197C48.8672 21.382 47.357 22.8315 45.2815 22.8315L40 22.8315ZM44.944 16.2584C45.9987 16.2584 46.6483 15.4916 46.6483 14.632C46.6483 13.8062 46.0493 12.9635 44.944 12.9635H41.7802V16.2584H44.944ZM41.7802 21.2472H45.2815C46.4036 21.2472 47.1123 20.4298 47.1123 19.4859C47.1123 18.5843 46.3699 17.75 45.2815 17.75H41.7802V21.2472ZM52.4687 14.7416V19.3006C52.4687 20.6405 53.2027 21.4157 54.443 21.4157C55.7169 21.4157 56.7209 20.6405 56.7209 19.3006V14.7416H58.3914V22.8315H56.7125V21.8118C56.4425 22.2247 55.6747 23 54.1814 23C51.9709 23 50.7982 21.618 50.7982 19.6545V14.7416H52.4687ZM61.5711 20.1264C62.0267 20.9186 62.8029 21.4663 63.8322 21.4663C64.7013 21.4663 65.3509 21.1208 65.3509 20.573C65.3509 19.9748 64.8531 19.7894 63.6635 19.5197C61.9255 19.132 60.6853 18.5843 60.6853 16.9832C60.6853 15.5169 62.0267 14.5731 63.6804 14.5731C65.1906 14.5731 66.3464 15.3568 66.8864 16.2416L65.7643 17.2023C65.3256 16.5787 64.6337 16.0984 63.6804 16.0984C62.8789 16.0984 62.3389 16.4354 62.3389 16.9579C62.3389 17.5731 62.9379 17.7416 64.1275 18.0281C65.8908 18.4579 67.0383 19.0309 67.0383 20.573C67.0383 22.0477 65.5534 23 63.8322 23C62.2545 23 60.9553 22.2753 60.3309 21.1292L61.5711 20.1264ZM69.906 11C70.5135 11 70.9438 11.4214 70.9438 12.0281C70.9438 12.6348 70.5135 13.0562 69.906 13.0562C69.2986 13.0562 68.8767 12.6348 68.8767 12.0281C68.8767 11.4213 69.2985 11 69.906 11ZM69.0707 22.8315V14.7416H70.7413V22.8315H69.0707ZM73.3057 22.8315V14.7416H74.9846V15.7612C75.2546 15.3484 76.0224 14.5731 77.4735 14.5731C79.7009 14.5731 80.8736 15.9551 80.8736 17.9185V22.8315H79.2031V18.2724C79.2031 16.9326 78.4691 16.1574 77.212 16.1574C75.9802 16.1574 74.9762 16.9326 74.9762 18.2724V22.8315H73.3057ZM86.9219 14.5731C89.2842 14.5731 90.8198 16.3259 90.8198 18.4916C90.8198 18.7444 90.8029 19.0056 90.7523 19.2668H84.4667C84.5427 20.4803 85.5804 21.4326 86.9809 21.4326C87.9934 21.4326 88.8033 21.0028 89.4108 20.0506L90.6426 20.9438C89.8917 22.2921 88.4152 23 86.9809 23C84.5343 23 82.7372 21.1966 82.7372 18.795C82.7372 16.3848 84.4667 14.5731 86.9219 14.5731ZM89.124 18.0197C89.0227 16.882 88.0693 16.0815 86.905 16.0815C85.6648 16.0815 84.7199 16.882 84.5089 18.0197H89.124ZM93.4174 20.1264C93.873 20.9186 94.6492 21.4663 95.6785 21.4663C96.5475 21.4663 97.1971 21.1208 97.1971 20.573C97.1971 19.9748 96.6993 19.7894 95.5098 19.5197C93.7717 19.132 92.5315 18.5843 92.5315 16.9832C92.5315 15.5169 93.873 14.5731 95.5266 14.5731C97.0369 14.5731 98.1927 15.3568 98.7327 16.2416L97.6105 17.2023C97.1718 16.5787 96.48 16.0984 95.5266 16.0984C94.7251 16.0984 94.1851 16.4354 94.1851 16.9579C94.1851 17.5731 94.7842 17.7416 95.9738 18.0281C97.7371 18.4579 98.8845 19.0309 98.8845 20.573C98.8845 22.0477 97.3996 23 95.6785 23C94.1008 23 92.8015 22.2753 92.1772 21.1292L93.4174 20.1264ZM101.533 20.1264C101.989 20.9186 102.765 21.4663 103.794 21.4663C104.663 21.4663 105.313 21.1208 105.313 20.573C105.313 19.9748 104.815 19.7894 103.625 19.5197C101.887 19.132 100.647 18.5843 100.647 16.9832C100.647 15.5169 101.989 14.5731 103.642 14.5731C105.152 14.5731 106.308 15.3568 106.848 16.2416L105.726 17.2023C105.287 16.5787 104.596 16.0984 103.642 16.0984C102.841 16.0984 102.301 16.4354 102.301 16.9579C102.301 17.5731 102.9 17.7416 104.089 18.0281C105.853 18.4579 107 19.0309 107 20.573C107 22.0477 105.515 23 103.794 23C102.216 23 100.917 22.2753 100.293 21.1292L101.533 20.1264Z"
          fill="black"
        />
        <path
          className={short_logo}
          d="M26.8579 18.1642C28.6391 13.6341 27.182 11.3886 23.9345 11.3694C18.7194 11.3386 13.4921 16.8976 8.82871 18.5241C4.57341 20.0083 1.14017 19.4118 0.183261 16.125C-2.52249 6.83122 25.5117 -8.99114 32.9162 6.52823C38.5187 18.5701 21.101 33.7804 10.4054 33.9983C1.88039 34.1719 7.20724 21.1513 13.2564 21.1715C14.6658 21.1762 16.0829 21.7293 16.1767 23.1336C16.2699 24.5265 14.5761 25.6947 13.2488 26.9529C10.9996 29.0848 10.3498 30.638 10.9553 31.377C11.5609 32.116 13.449 31.9728 16.6564 29.8147C21.808 26.3485 25.2272 22.3243 26.8579 18.1642Z"
        />
      </svg>
    </a>
  </div>
));
